/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPentagon: {
  name: 'pentagon';
  data: string;
} = {
  name: 'pentagon',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.853 2.582a2 2 0 0 1 2.294 0l8.798 6.159a2 2 0 0 1 .733 2.322l-3.499 9.62A2 2 0 0 1 17.3 22H6.7a2 2 0 0 1-1.88-1.317l-3.498-9.62a2 2 0 0 1 .733-2.322l8.798-6.159Zm9.945 7.797L12 4.221l-8.798 6.158L6.7 20h10.6l3.498-9.62Z" fill="currentColor"/></svg>`,
};
